import { useState } from 'react';
import PinInput from '../Login/utils/PinInput';

import { useTranslation } from "react-i18next";

const Pin = ({ onPin, onChangePin, onLogout, loading = false }) => {
  const { t } = useTranslation("auth");

  const [formData, setFormData] = useState({ pin: '' });
  const [errors, setErrors] = useState({});

  const handleInputChange = (field, value) => {
    setFormData(prev => {
      const updated = { ...prev, [field]: value };

      if (errors[field]) {
        setErrors(prevErrors => ({ ...prevErrors, [field]: '' }));
      }

      if (field === 'pin' && value.length === 4) {
        handleSubmit(updated);
      }

      return updated;
    });
  };

  const handleSubmit = async (data) => {
    try {
      const success = await onPin(data);

      if (!success) {
        setFormData({ pin: '' });
        setErrors({ pin: t("WRONG_PIN_ERR") });
        
        setTimeout(() => {
          setErrors({});
        }, 3000);
      }
    } catch (err) {
      console.error('PIN error:', err?.response?.data?.error);
      setFormData({ pin: '' });
      setErrors({ pin: t("PIN_CHECK_ERR") });
      
      setTimeout(() => {
        setErrors({});
      }, 3000);
    }
  };

  const handleChangePin = () => {
    if (onChangePin) {
      onChangePin();
    }
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1 flex flex-col justify-center px-6 py-12">
        <div className="w-full max-w-md mx-auto bg-white rounded-2xl p-8 shadow-xl">
          
          <PinInput
            value={formData.pin}
            onChange={(value) => handleInputChange('pin', value)}
            error={errors.pin}
            disabled={loading}
          />
          
          <div className="mt-8 space-y-4">
            <button
              onClick={handleChangePin}
              className="w-full text-blue-500 font-medium py-3 hover:text-blue-600 disabled:opacity-60 transition-colors"
              disabled={loading}
            >
              {t("CHANGE_PIN_CODE")}
            </button>
            
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="bg-white px-4 text-gray-500">или</span>
              </div>
            </div>
            
            <button
              onClick={handleLogout}
              className="w-full text-gray-500 font-medium py-3 hover:text-gray-600 disabled:opacity-60 transition-colors"
              disabled={loading}
            >
              {t("LOG_OUT")}
            </button>
          </div>
        </div>

        {loading && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-6 flex flex-col items-center">
              <div className="w-8 h-8 border-3 border-blue-200 border-t-blue-600 rounded-full animate-spin mb-4"></div>
              <p className="text-gray-600 font-medium">{t("CHECKING_CODE")}...</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Pin;